import React from 'react';
import AtlasV2ConversionV2ProductGrid from 'src/components/AtlasV2Components/AtlasConversionV2PageComponents/AtlasV2ConversionV2ProductGrid';
import AtlasV2ConversionSplineV2Chart from 'src/components/AtlasV2Components/AtlasConversionV2PageComponents/AtlasV2ConversionV2SplineChart';
import AtlasV2ConversionV2TopEntityChart from 'src/components/AtlasV2Components/AtlasConversionV2PageComponents/AtlasV2ConversionV2TopEntityChart';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';

/**
 * Conversion V2 Page in traffic tab = traffic, subtab = conversion
 *
 */
export const AtlasConversionV2PageLayout = () => {
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <ChartContextProvider group={CHART_CONTEXT_GROUPS.CONVERSION_SPLINE.name} chartName={CHART_NAMES.CONVERSION_SPLINE_CHART}>
          <AtlasV2ConversionSplineV2Chart />
        </ChartContextProvider>
        {!isProductEntity && (
          <ChartContextProvider group={CHART_CONTEXT_GROUPS.CONVERSION_TOP_ENTITY.name} chartName={CHART_NAMES.CONVERSION_TOP_ENTITY_COLUMN}>
            <AtlasV2ConversionV2TopEntityChart />
          </ChartContextProvider>
        )}
        <AtlasV2ConversionV2ProductGrid />
      </Flex>
    </BasePageContainer>
  );
};
